import UserManagement from "../pages/admin/UserManagement";
import {InventoryManagement} from "../pages/supplier";
import BusinessCalendar from "../pages/admin/BusinessCalendar";
import RouteZonesPage from "../pages/admin/RouteZonesPage";
import CouponListPage from "../pages/admin/CouponListPage";
import {AdminInventoryPage} from "../pages/admin";

export const menuConfig = {
  admin: {
    title: "حساب کاربری",
    items: [
      {
        id: 'admin-profile',
        label: 'حساب کاربری',
        link: '',
        submenu: [
          {
            id: 'profile',
            label: 'پروفایل',
            link: '/admin-panel/profile/',
            component: 'AdminProfile'
          },
          {
            id: 'password-setting',
            label: 'تغییر رمز عبور',
            link: '/password-setting/',
            component: 'PasswordSettingsPage'
          }
          ]
      },
      {
        id: 'user-management',
        label: 'مدیریت حساب‌های کاربری',
        link: '',
        submenu: [
          {
            id: 'employee-user-management',
            label: 'کارمندان',
            link: '/admin-panel/employee-user-management/',
            component: 'EmployeeUserManagement'
          },
          {
            id: 'customer-user-management',
            label: 'مشتریان',
            link: '/admin-panel/customer-user-management/',
            component: 'CustomerUserManagement'
          },
          {
            id: 'supplier-user-management',
            label: 'تأمین کنندگان',
            link: '/admin-panel/supplier-user-management/',
            component: 'SupplierUserManagement'
          },
          {
            id: 'carrier-user-management',
            label: 'شرکت های حمل',
            link: '/admin-panel/carrier-user-management/',
            component: 'CarrierUserManagement'
          },
          {
            id: 'driver-user-management',
            label: 'رانندگان',
            link: '/admin-panel/driver-user-management/',
            component: 'DriverUserManagement'
          },
          {
            id: 'permission-management',
            label: 'مدیریت دسترسی',
            link: '/admin-panel/permission-management/',
            component: 'PermissionManagement'
          }
        ]
      },
      {
        id: 'Product-content-management',
        label: 'مدیریت محتوی کالا',
        link: '',
        submenu: [
            {
            id: 'content-management',
            label: 'بازرسی محتوی کالا',
            link: '/admin-panel/content-inspection-management/',
            component: 'ContentInspectionManagement'
          },
          {
            id: 'product-management',
            label: 'مدیریت کالا',
            link: '/admin-panel/product-management/',
            component: 'AdminProductManagement'
          },
          {
            id: 'category-management',
            label: 'مدیریت دسته‌بندی',
            link: '/admin-panel/category-management/',
            component: 'CategoryManagement'
          },
          {
            id: 'attribute-management',
            label: 'مدیریت مشخصه‌ها',
            link: '/admin-panel/attribute-management/',
            component: 'AttributeManagement'
          }
        ]
      },
      {
        id: 'pricing-management',
        label: 'مدیریت قیمت‌گذاری',
        link: '',
        submenu: [
          {
            id: 'campaign-management',
            label: 'مدیریت رویدادها',
            link: '/admin-panel/campaigns/',
            component: 'CampaignManagementPage'
          },
          {
            id: 'coupon-management',
            label: 'مدیریت تخفیف',
            link: '/admin-panel/coupon-management/',
            component: 'CouponListPage'
          }
        ]
      },
      {
        id: 'supplier-management',
        label: 'مدیریت حساب‌ تأمین کنندگان',
        link: '',
        submenu: [
          {
            id: 'supplier-commission-management',
            label: 'مدیریت کمیسیون',
            link: '/admin-panel/supplier-commission-management/',
            component: 'SupplierCommissionManagement'
          },
          {
            id: 'supplier-performance-evaluation',
            label: 'نظارت بر عملکرد',
            link: '/admin-panel/supplier-performance-evaluation/',
            component: 'SupplierPerformanceEvaluation'
          }
        ]
      },
      {
        id: 'inventory-management',
        label: 'مدیریت موجودی',
        link: '/admin-panel/admin-inventory-page/',
        component: 'AdminInventoryPage'
      },
      {
        id: 'order-management',
        label: 'مدیریت سفارشات',
        link: '/admin-panel/order-management/',
        component: 'AdminOrdersPage'
      },
      {
        id: 'shipment-management',
        label: 'مدیریت حمل و نقل',
        link: '/admin-panel/shipment-management/',
        component: 'AdminShipmentManagement'
      },
      {
        id: 'carrier-management',
        label: 'مدیریت حساب شرکت‌های حمل',
        link: '',
        submenu: [
          {
            id: 'carrier-commission-management',
            label: 'مدیریت کمیسیون',
            link: '/admin-panel/carrier-commission-management/',
            component: 'CarrierCommissionManagement'
          },
          {
            id: 'carrier-performance-evaluation',
            label: 'نظارت بر عملکرد',
            link: '/admin-panel/carrier-performance-evaluation/',
            component: 'CarrierPerformanceManagement'
          }
        ]
      },
      {
        id: 'driver-management',
        label: 'مدیریت حساب‌های رانندگان',
        link: '/admin-panel/driver-management/',
        component: 'AdminDriverManagement'
      },
      {
        id: 'payment-management',
        label: 'مدیریت پرداخت‌ها',
        link: '/admin-panel/payment-management/',
        component: 'PaymentManagement'
      },
      {
        id: 'address-management',
        label: 'مدیریت آدرس ها',
        link: '',
        submenu: [
          {
            id: 'region-management',
            label: 'مدیریت مناطق',
            link: '/admin-panel/region-management/',
            component: 'RegionManagementPage'
          },
          {
            id: 'address',
            label: 'آدرس ها',
            link: '/admin-panel/address/',
            component: 'AddressManagement'
          }
        ]
      },
      {
        id: 'internal-service-management',
        label: 'مدیریت سرویس های داخلی',
        link: '',
        submenu: [
          {
            id: 'business-calendar',
            label: 'مدیریت تقویم اختصاصی',
            link: '/admin-panel/business-calendar/',
            component: 'BusinessCalendar'
          },
          {
            id: 'distance-duration-from-to',
            label: 'مدیریت ماتریس از-به',
            link: '/admin-panel/distance-duration-from-to/',
            component: 'DistanceDurationFromTo'
          }
        ,
          {
            id: 'route-zones',
            label: 'مدیریت پارامترهای لجستیکی',
            link: '/admin-panel/route-zones/',
            component: 'RouteZonesPage'
          }
        ]
      },
      {
        id: 'Communication-management',
        label: 'مدیریت اطلاع رسانی',
        link: '',
        submenu: [
          {
            id: 'faq',
            label: 'مدیریت پرسش های متداول',
            link: '/admin-panel/faq/',
            component: 'FaqPage'
          }
        ]
      },
      {
        id: 'support',
        label: 'پشتیبانی',
        link: '/admin-panel/support/',
        component: ''
      }
    ]
  },

  customer: {
    title: "حساب کاربری",
    items: [
      {
        id: 'customer-profile',
        label: 'مشخصات کاربری',
        link: '',
        submenu: [
          {
            id: 'profile',
            label: 'پروفایل',
            link: '/customer-panel/profile/' ,
            component:'CustomerProfile'
            },
          {
            id: 'addresses',
            label: 'آدرس‌ها',
            link: '/customer-panel/address/',
            component: 'CustomerAddress'
          },
          {
            id: 'bank-accounts',
            label: 'حساب‌های بانکی',
            link: '/customer-panel/bank-account/',
            component:'CustomerBankAccount'
          },
          {
            id: 'password-setting',
            label: 'تغییر رمز عبور',
            link: '/password-setting/',
            component: 'PasswordSettingsPage'
          }
        ]
      },
      {
        id: 'orders',
        label: 'سفارش‌ها',
        link: '/customer-panel/order/',
        component:'CustomerOrder'
      },
      {
        id: 'favorite',
        label: 'علاقمندی‌ها',
        link: '/customer-panel/favorite/',
        component:'CustomerFavorite'
      },
      {
        id: 'support',
        label: 'تماس با پشتیبانی',
        link: '/customer-panel/contact-support/',
        component:'ContactSupport'
      },
    ]
  },

  supplier: {
    title: "حساب کاربری",
    items: [
      {
        id: 'supplier-profile',
        label: 'مشخصات کاربری',
        link: '',
        submenu: [
          {
            id: 'profile',
            label: 'پروفایل',
            link: '/supplier-panel/profile/',
            component:'SupplierProfile'
          },
          {
            id: 'addresses',
            label: 'آدرس‌ انبارها',
            link: '/supplier-panel/address/',
            component:'SupplierAddress'
          },
          {
            id: 'bank-accounts',
            label: 'حساب‌های بانکی',
            link: '/supplier-panel/bank-account/',
            component:'SupplierBankAccount'
          },
          {
            id: 'password-setting',
            label: 'تغییر رمز عبور',
            link: '/password-setting/',
            component: 'PasswordSettingsPage'
          }
        ]
      },
      {
        id: 'products',
        label: 'مدیریت کالاها',
        link: '/supplier-panel/supplier-product-management/',
        component:'SupplierProductManagement'
      },
      {
        id: 'inventory-pricing0',
        label:'مدیریت موجودی و قیمت گذاری',
        link: '',
        submenu:
        [
          {
            id:'inventory-management',
            label: 'مدیریت موجودی',
            link: '/supplier-panel/inventory-management/',
            component:'InventoryManagement'
          },
          {
            id:'discount-management',
            label: 'مدیریت رویدادها',
            link: '/supplier-panel/discount-management/',
            component:'SupplierDiscountManagement'
        }
        ]
      },
      {
        id: 'order-management',
        label: 'مدیریت سفارش‌ها',
        link: '',
        submenu: [
          {
            id:'order',
            label: 'پردازش سفارش‌ها',
            link:'/supplier-panel/order/',
            component:'SupplierShipmentFulfillment'
          },
            {
            id:'completed-order',
            label: 'رهگیری سفارش‌ها',
            link:'/supplier-panel/completed-order/',
            component:'SupplierOrder'
          }
        ]
      },
      {
        id: 'delivery-management',
        label: 'مدیریت ارسال',
        link: '',
        submenu: [
          {
            id:'delivery-duaration',
            label: 'زمان ارسال',
            link:'/supplier-panel/delivery-duaration/',
            component:'SupplierDeliveryDuration'
          },
            {
            id:'logistics-parameters',
            label: 'تنظیم پارامترهای لجستیکی',
            link:'/supplier-panel/logistics-parameters/',
            component:'SupplierLogisticsParameters'
          }
        ]
      },
      {
        id: 'payment-management',
        label: 'مدیریت مالی',
        link: '/supplier-panel/financial-management/',
        component: 'SupplierFinancialManagement'
      },
      {
        id: 'support',
        label: 'تماس با پشتیبانی',
        link: '/supplier-panel/contact-support/',
        component: 'ContactSupport'
      }
    ]
  },

  carrier: {
    title: "حساب کاربری",
    items: [
      {
        id: 'carrier-profile',
        label: 'مشخصات کاربری',
        link: '',
        submenu: [
          {
            id: 'profile',
            label: 'پروفایل',
            link: '/carrier-panel/profile/',
            component:'CarrierProfile'
          },
          {
            id: 'addresses',
            label: 'آدرس‌ها',
            link: '/carrier-panel/address/',
            component:'CarreirAddress'
          },
          {
            id: 'bank-accounts',
            label: 'حساب‌های بانکی',
            link: '/carrier-panel/bank-account/',
            component:'CarrierBankAccount'
          }
        ]
      },
      {
        id: 'shipment-management',
        label: 'مدیریت حمل و نقل',
        link: '',
        submenu: [
          {
            id:'shipment',
            label: 'حمل‌های در حال انجام',
            link:'/carrier-panel/shipment',
            component:'CarrierShipmnet'
          },
            {
            id:'completed-shipment',
            label: 'حمل‌های تکمیل شده',
            link:'/carrier-panel/completed-shipment/',
            component:'CarrierCompletedShipment'
          }
        ]
      },
      {
        id: 'driver-management',
        label: 'مدیریت رانندگان',
        link: '/carrier-panel/driver-management/',
        component:'CarrierDriverManagement'
      },
      {
        id: 'payment-management',
        label: 'مدیریت مالی',
        link: '/carrier-panel/financial-management/',
        component:'CarrierFinancialManagement'
      },
      {
        id: 'support',
        label: 'تماس با پشتیبانی',
        link: '/carrier-panel/contact-support/',
        component:'ContactSupport'
      }
    ]
  },

  driver: {
    title: "حساب کاربری",
    items: [
      {
        id: 'driver-profile',
        label: 'مشخصات کاربری',
        link:'',
        submenu: [
          {
            id: 'profile',
            label: 'پروفایل',
            link: '/driver-panel/profile/',
            component:'DriverProfile'
          },
          {
            id: 'addresses',
            label: 'آدرس‌ها',
            link: '/driver-panel/address/',
            component:'DriverAddress'
          },
          {
            id: 'bank-accounts',
            label: 'حساب‌های بانکی',
            link: '/driver-panel/bank-account/',
            component:'DriverBankAccount'
          }
        ]
      },
      {
        id: 'shipment-management',
        label: 'مدیریت حمل و نقل',
        link: '/driver-panel/shipment/',
        component:'DriverShipment'
      },
      {
        id: 'support',
        label: 'تماس با پشتیبانی',
        link: '/driver-panel/contact-support/',
        component:'ContactSupport'
      }
    ]
  }
};